import IDimensions from '../../gqlCommon/model/IDimensions';
import { InsuranceFormInput } from '../../__generated__/globalTypes';

const insuranceBlockService = {
  getFormInput: (dimensions: IDimensions): InsuranceFormInput => {
    const key = `${dimensions.country}_${dimensions.brand}_insurance_block_input`;
    const formData = localStorage.getItem(key);

    return formData ? { formData } : null;
  },
};

export default insuranceBlockService;
